import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { InnovationsDataItem } from 'client/bundles/types';
import Card from 'client/components/card';
import Help from 'client/components/help';
import SvgIcon from 'client/components/svg-icon';

import './index.css';

const b = cn('about-innovations-cards');

interface Props {
    data: InnovationsDataItem[];
    mix?: string;
    theme: 'white' | 'blue';
}

export default class AboutInnovationsCards extends Component<Props> {
    render() {
        const { data, mix, theme } = this.props;

        return (
            <div className={b('', [mix])}>
                {data.map(({ id, icon, text, help }) => (
                    <Card key={id} theme={theme}>
                        <div className={b('header')}>
                            <SvgIcon icon={icon} mix={b('icon')} />
                            {help && (
                                <Help content={help} mix={b('help')} />
                            )}
                        </div>
                        <div
                            className={b('text')}
                            dangerouslySetInnerHTML={{ __html: text }}
                            />
                    </Card>
                ))}
            </div>
        );
    }
}
